export interface RequestPostResendBookingEmailInterface {
  booking_internal_no: string;
  doc_type: "payment" | "voucher";
  email: string[];
}
export class ResponsePostResendBookingEmailPresenter {
  status: boolean;

  statusCode: string;

  message: string;

  data: {
    bookingId: number;
    reservationNo: string;
    status: string;
    statusCode: number;
  };

  constructor(val: any) {
    this.status = val?.status || false;
    this.statusCode = val?.statusCode || "";
    this.message = val?.message || "";
    this.data = {
      bookingId: val?.data?.bookingId || "",
      reservationNo: val?.data?.reservationNo || "",
      status: val?.data?.status || "",
      statusCode: val?.data?.statusCode || 0,
    };
  }
}
